import api from './api';

export const userService = {
  async getUsers(params = {}) {
    const response = await api.get('/users', { params });
    return response.data;
  },

  async getUser(id) {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  async createUser(userData) {
    // Si hay una foto o disciplines, usar FormData
    if (userData.photo instanceof File || (userData.disciplines && Array.isArray(userData.disciplines))) {
      const formData = new FormData();
      
      Object.keys(userData).forEach(key => {
        const value = userData[key];
        if (key === 'photo' && value instanceof File) {
          formData.append('photo', value);
        } else if (key === 'disciplines' && Array.isArray(value)) {
          // Enviar cada disciplina como un elemento del array
          value.forEach(discipline => {
            formData.append('disciplines[]', discipline);
          });
        } else if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value);
        }
      });

      const response = await api.post('/users', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      const response = await api.post('/users', userData);
      return response.data;
    }
  },

  async updateUser(id, userData) {
    // Si hay una foto o disciplines, usar FormData
    if (userData.photo instanceof File || (userData.disciplines && Array.isArray(userData.disciplines))) {
      const formData = new FormData();
      
      Object.keys(userData).forEach(key => {
        const value = userData[key];
        if (key === 'photo' && value instanceof File) {
          formData.append('photo', value);
        } else if (key === 'disciplines' && Array.isArray(value)) {
          // Enviar cada disciplina como un elemento del array
          value.forEach(discipline => {
            formData.append('disciplines[]', discipline);
          });
        } else if (value !== null && value !== undefined && value !== '') {
          formData.append(key, value);
        }
      });

      // Usar POST con _method=PUT para FormData
      formData.append('_method', 'PUT');
      
      const response = await api.post(`/users/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    }
  },

  async deleteUser(id) {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
};
